import RegisterPartnerSuccess from './register-partner-success-container';

export default RegisterPartnerSuccess;
